export const formatPhoneNumber = (value: string) => {
  const clearedPhone = value.replace(/(^\+?7)|\D/g, '');

  return `+7${clearedPhone}`.replace(/^\+7(\d{1,3})(\d{1,3})?(\d{1,2})?(\d{1,2})?.*/g, (_, g1, g2, g3, g4) => {
    switch (true) {
      case Boolean(g1 && g2 && g3 && g4):
        return `+7 (${g1}) ${g2} ${g3} ${g4}`;
      case Boolean(g1 && g2 && g3):
        return `+7 (${g1}) ${g2} ${g3}`;
      case Boolean(g1 && g2):
        return `+7 (${g1}) ${g2}`;
      case Boolean(g1):
        return `+7 ${g1}`;
      /* istanbul ignore next */
      default:
        return '+7';
    }
  });
};
